<template>
  <div>
    <h3 class="primary--text" style="text-align: end;">Quote #{{ booking.order }}</h3>
    <v-divider class="mb-4"></v-divider>
    <h2 class="my-5" style="text-align: left;"> {{ booking.capturedAddress.split(', USA').join(' ') }} </h2>
    <v-row>
      <v-col align="left">
        <p style="font-size: 26px;"> Choose date and time </p>
      </v-col>
    </v-row>
    <v-row :style="$vuetify.breakpoint.smAndDown ? 'display: block;' : ''">
      <v-col>
        <v-col>
          <v-date-picker
            v-model="date"
            full-width
            color="primary"
          ></v-date-picker>
        </v-col>
        <v-col>
          <v-select
              filled
              prepend-inner-icon="mdi-clock"
              placeholder="  Time"
              :items="preferredTimes"
              v-model="preferredTime"
          ></v-select>
        </v-col>
      </v-col>
      <v-col>
        <h3 style="text-align: left;"> Special Instructions </h3>
        <v-textarea
          filled
          height="150"
          placeholder="Type special instructions..."
          hint="Instructions for the driver"
          v-model="instructions"
        ></v-textarea> 
        <v-row no-gutters v-if="(this.bookings.length === 1 && this.client.card)">
          <v-col> 
            <v-text-field
              filled
              height="50"
              label="Promotion code"
              hint="Enter your promotion code to get 25% off"
              v-model="promoCode"
              v-on:change="checkPromo()"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    
    <v-row :style="$vuetify.breakpoint.smAndDown ? 'display: block;' : ''">
      <v-col align="left">
        <h2 class="primary--text">R {{ booking.cost.value }}</h2>
        <span>Upon order completion</span>
      </v-col>
      <v-col :align="$vuetify.breakpoint.smAndDown ? 'right' : ''">
        <v-btn 
        rounded 
        outlined 
        style="border: 1px solid black;" 
        height="60" 
        width="200" 
        v-on:click="cancelQuote">Cancel</v-btn>
      </v-col>
      <v-col :align="$vuetify.breakpoint.smAndDown ? 'right' : ''">
        <v-btn 
        rounded
        height="60" 
        width="200"
        class="primary mr-2" 
        v-on:click="bookFromQuote">Confirm Booking</v-btn>
      </v-col>
    </v-row>
    <br/><br/><br/>
  </div>
</template>

<script>
export default {
  name: 'QuoteBooking',
  props: {
    booking: Object
  },
  watch: {
    bookingError(error) {
      alert(error.message);
      void this.$router.go();
    }
  },
  data () {
    return {
      date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      preferredTime: undefined,
      preferredTimes: [ 'In the Morning', 'In the Afternoon' ],
      promoCode: '',
      instructions: '',
    }
  },
  computed: {
    bookings() {
      return this.$store.getters.getAllBookings;
    },
    bookingError() {
      return this.$store.getters.getBookingError;
    },
    client() {
      return this.$store.getters['auth/getUser'];
    }
  },
  methods: {
    checkPromo (){
      if(this.promoCode != '#itssorted1122'){
        alert('Incorrect code. Please enter the correct discount code');
        return this.promoCode = '';
      }

    },
    async bookFromQuote() {
      if (!this.date) {
        alert('Please select a preferred date for service');
        return;
      }
      if (!this.preferredTime) {
        alert('Please select a preferred time for service');
        return;
      }
      await this.$store.dispatch('updateBooking', {
        ...this.booking,
        status: {
          status: 'SCHEDULING',
          type: this.booking.vehicle.type.toLowerCase().includes('truck') ? 'COLLECTION' : 'DELIVERY'
        },
        cost: {
          currency: 'USD',
          symbol: '$',
          value: `${this.promoCode ? parseInt(this.booking.cost.value) - (parseInt(this.booking.cost.value)*0.25) : this.booking.cost.value}`
        },
        customer: this.client,
        promotion: this.promoCode == '#itssorted1122' ? this.promoCode : '',
        preferredTime: this.preferredTime == 'In the Morning' ? 'AM' : 'PM',
        preferredDate: this.date,
        instructions: this.instructions
      }).then(() => {
        this.$router.push('/dashboard/bookings');
      });
    },
    async cancelQuote() {
      await this.$store.dispatch('deleteBooking', this.booking.id);
    }
  }
}
</script>

<style scoped>

</style>